"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var csod = require("player-core");
var View_1 = require("./View");
var GridLayout_1 = require("player-layout-controls/controls/GridLayout");
exports.LayoutControlsGridLayout = GridLayout_1.GridLayout;
var GridCol_1 = require("player-layout-controls/controls/GridCol");
exports.LayoutControlsGridCol = GridCol_1.GridCol;
var RouteLink_1 = require("player-routing-controls/controls/RouteLink");
exports.RoutingControlsRouteLink = RouteLink_1.RouteLink;
var Icon_1 = require("../Icon/Icon");
exports.Icon = Icon_1.Icon;
var Text_1 = require("player-common-controls/controls/Text");
exports.CommonControlsText = Text_1.Text;
var Hyperlink_1 = require("player-common-controls/controls/Hyperlink");
exports.CommonControlsHyperlink = Hyperlink_1.Hyperlink;
var JobDetailsNavigation = (function (_super) {
    __extends(JobDetailsNavigation, _super);
    function JobDetailsNavigation(props) {
        var _this = _super.call(this, props) || this;
        _this._setState = _this._setState.bind(_this);
        _this._proxyEvent = _this._proxyEvent.bind(_this);
        _this.forceRender = _this.forceRender.bind(_this);
        _this.view = View_1.view.call(_this, _this.props);
        _this.state = {
            viewModel: __assign({}, _this.view.state, _this.props),
            isInit: false
        };
        _this._trackers = {};
        if (typeof csod.context.tracking !== 'undefined') {
            var monikerCallback_1 = function (moniker, eventName) {
                var evt = document.createEvent("Event");
                evt.initEvent("player-" + moniker + "-" + eventName, true, false);
                window.dispatchEvent(evt);
            };
            for (var reporter in csod.context.tracking) {
                var _loop_1 = function (moniker) {
                    var events = csod.context.tracking[reporter][moniker];
                    var _loop_2 = function (i, l) {
                        var event_1 = events[i];
                        var monikerKey = moniker + '.' + event_1;
                        if (typeof this_1._trackers[monikerKey] === 'undefined')
                            this_1._trackers[monikerKey] = function () { monikerCallback_1(moniker, event_1); };
                    };
                    for (var i = 0, l = events.length; i < l; i++) {
                        _loop_2(i, l);
                    }
                };
                var this_1 = this;
                for (var moniker in csod.context.tracking[reporter]) {
                    _loop_1(moniker);
                }
            }
        }
        return _this;
    }
    JobDetailsNavigation.prototype.componentDidMount = function () {
        var _this = this;
        this.view.initialize
            ? this.view.initialize(this.props)
                .then(function () {
                _this.view.mounted ? _this.view.mounted() : null;
                _this.setState({
                    isInit: true,
                    viewModel: __assign({}, _this.view.state, _this.props)
                });
            })
            : null;
    };
    JobDetailsNavigation.prototype.componentWillReceiveProps = function (props) {
        var _this = this;
        this.view.receivedProps
            ? this.view.receivedProps(props).then(function () { return _this._setState(_this.state.viewModel, _this.view.state, props); })
            : this._setState(this.state.viewModel, this.view.state, props);
    };
    JobDetailsNavigation.prototype.componentWillUnmount = function () {
        this.view.unmount ? this.view.unmount() : null;
    };
    JobDetailsNavigation.prototype.forceRender = function (cb) {
        this.setState({
            viewModel: __assign({}, this.state.viewModel, this.view.state, this.props)
        }, cb ? cb : function () { });
    };
    JobDetailsNavigation.prototype._setState = function (viewModel, viewState, props) {
        this.setState({ viewModel: __assign({}, viewModel, viewState, props) });
    };
    JobDetailsNavigation.prototype._proxyTrackEvent = function (moniker, eventID, eventName) {
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var args = [];
        for (var i = 3; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        var monikerKey = moniker + '.' + eventID;
        var monikerCallback = this._trackers[monikerKey] || function () { };
        return this._procesEvent(eventName, args, 4, monikerCallback);
    };
    JobDetailsNavigation.prototype._proxyEvent = function (eventName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var args = [];
        for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return this._procesEvent(eventName, args, 2, function () { });
    };
    JobDetailsNavigation.prototype._procesEvent = function (eventName, args, repeaterArgIndex, callback) {
        args = pushAndShiftArgs(args, repeaterArgIndex);
        if (typeof this.view.events[eventName] === 'function') {
            var self_1 = this;
            return function proxy() {
                var combinedArgs = [].slice.call(arguments).concat(args);
                var shouldRender = self_1.view.events[eventName].apply(self_1, combinedArgs);
                if (shouldRender !== false) {
                    csod.engine.commit();
                }
                csod.lastEventDate = new Date();
                callback();
            };
        }
        else {
            return function noFunc() {
                if (eventName) {
                    csod.logger.warn(eventName + ' is not a valid function. Please check for typos.');
                    csod.lastEventDate = new Date();
                }
                callback();
            };
        }
    };
    JobDetailsNavigation.prototype.render = function () {
        var _this = this;
        var PlayerRepeater = csod.engine.controls.Player.Repeater;
        var PlayerVisible = csod.engine.controls.Player.Visible;
        var PlayerSwitch = csod.engine.controls.Player.Switch;
        var $this = this;
        var root_handler = function () {
            return [React.createElement(GridLayout_1.GridLayout, { key: 0, gutterHorizontal: "Medium", children: [React.createElement(GridCol_1.GridCol, { key: 0, width: "Fill", children: [React.createElement(RouteLink_1.RouteLink, { key: 0, to: $this.state.viewModel.searchUrl, children: [React.createElement(Icon_1.Icon, { key: 0, iconName: "right-cursor", color: $this.state.viewModel.iconColor, rotationDegree: "180", shouldFlipForRtl: true }), React.createElement(Text_1.Text, { key: 1, text: " " }), React.createElement(Text_1.Text, { key: 2, text: $this.state.viewModel.backText, color: "Primary", tag: "backToSearchLink" })] })] }), React.createElement(PlayerVisible, { key: 1, visible: false, children: [React.createElement(GridCol_1.GridCol, { key: 0, width: "Auto", children: [React.createElement(Hyperlink_1.Hyperlink, { key: 0, type: "Action", onClick: _this._proxyEvent("onPrev"), children: [React.createElement(Icon_1.Icon, { key: 0, iconName: "right-cursor", color: $this.state.viewModel.iconColor, rotationDegree: "180", shouldFlipForRtl: true }), React.createElement(Text_1.Text, { key: 1, text: $this.state.viewModel.prevText, color: $this.state.viewModel.textColor })] })] }), React.createElement(GridCol_1.GridCol, { key: 1, width: "Auto", children: [React.createElement(Hyperlink_1.Hyperlink, { key: 0, type: "Action", onClick: _this._proxyEvent("onNext"), children: [React.createElement(Text_1.Text, { key: 0, text: $this.state.viewModel.nextText, color: $this.state.viewModel.textColor }), React.createElement(Icon_1.Icon, { key: 1, iconName: "right-cursor", color: $this.state.viewModel.iconColor, shouldFlipForRtl: true })] })] })] })] })];
        };
        return (React.createElement("div", { className: "p-view-jobdetailsnavigation" }, this.state.isInit ? root_handler() : null));
    };
    return JobDetailsNavigation;
}(React.Component));
JobDetailsNavigation.defaultProps = {
    iconColor: "", searchUrl: "", textColor: "", backText: "", prevText: "", nextText: "", onPrev: function () { }, onNext: function () { }
};
exports.JobDetailsNavigation = JobDetailsNavigation;
function pushAndShiftArgs(args, repeaterArgIndex) {
    if (args[repeaterArgIndex] === 'repeaterArgs') {
        args.push(args.shift());
        args.push(args.shift());
        args.shift();
        pushAndShiftArgs(args, repeaterArgIndex);
    }
    return args;
}
if (!window["__LOCALES__"])
    window["__LOCALES__"] = {};
window["__LOCALES__"]["JobDetailsNavigation"] = [];



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/.tmp/JobDetailsNavigation/JobDetailsNavigation.js
// module id = 971
// module chunks = 0